import { Component, OnInit, AfterViewInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from 'src/app/feature/auth/services/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-horizontal',
  templateUrl: './horizontal.component.html',
})

/**
 * Horizontal-layout component
 */
export class HorizontalComponent implements OnInit, AfterViewInit {

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  userLogin: any = null;
  private isRouterListenerInitialized = false;

  ngOnInit() {
    document.body.setAttribute('data-layout', 'horizontal');
    document.body.setAttribute('data-topbar', 'dark');
    document.body.removeAttribute('data-sidebar');
    document.body.removeAttribute('data-layout-size');
    document.body.removeAttribute('data-keep-enlarged');
    document.body.removeAttribute('data-sidebar-small');

  }

  ngAfterViewInit() {
    this.authService.getProfile().subscribe({
      next: (user: any) => {
        this.userLogin = user;

        // 3. Jalankan pengecekan awal
        this.checkRouteAndProfile(this.router.url);

        // 4. Jalankan pengecekan saat route berubah (pastikan hanya diset sekali)
        if (!this.isRouterListenerInitialized) {
          this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
              this.checkRouteAndProfile(event.urlAfterRedirects);
            }
          });
          this.isRouterListenerInitialized = true;
        }
      },
      error: (err) => {
        console.error('Gagal mengambil profil user', err);
        // Tambahkan redirect ke login jika ingin
      },
    });
  }

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
  }


  checkRouteAndProfile(currentUrl: string) {
    if (!this.userLogin.id) return; // ✅ Tambahan: pastikan userLogin tersedia

    const isLoginPage = currentUrl.includes('/auth/login');
    const isProfilePage = currentUrl.includes('/panel/data-diri');

    if (!isLoginPage && !isProfilePage) {
      const isProfileComplete = this.checkProfileCompletion();

      console.log(isProfileComplete);
      if (!isProfileComplete) {
        this.showIncompleteProfileWarning();
      }
    }
  }

  checkProfileCompletion(): boolean {
    
    return this.userLogin?.is_profile_completed == '1';
  }

  showIncompleteProfileWarning() {
    Swal.fire({
      title: 'Lengkapi Data Diri',
      text: 'Kamu harus melengkapi data diri terlebih dahulu sebelum melanjutkan.',
      icon: 'warning',
      confirmButtonText: 'Lengkapi Data Diri',
      showCancelButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      customClass: {
        confirmButton: 'btn-primary-swal-full',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.href = '/panel/data-diri';
      }
    });
  }
}
